module.exports = __webpack_public_path__ + "img/MufasaDasEisUndIch.012bec0b.jpg";